import { render, staticRenderFns } from "./text-toolbar.vue?vue&type=template&id=5432313f&scoped=true"
import script from "./text-toolbar.vue?vue&type=script&lang=js"
export * from "./text-toolbar.vue?vue&type=script&lang=js"
import style0 from "./text-toolbar.vue?vue&type=style&index=0&id=5432313f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5432313f",
  null
  
)

export default component.exports